export default __webpack_public_path__ + "static/media/19g30mmn.8677057c.jpeg";